import { motion } from 'framer-motion';

const NavigationDots = ({
  totalItems,
  activeIndex,
  onDotClick,
  primaryColor = '#10b981',
  secondaryColor = '#059669',
  className = '',
}) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center gap-2 ${className}`}
    >
      {Array.from({ length: totalItems }, (_, index) => (
        <motion.button
          key={index}
          className="btn p-0 border-0"
          onClick={() => onDotClick(index)}
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
          style={{
            width: activeIndex === index ? '32px' : '10px',
            height: '10px',
            borderRadius: '5px',
            background:
              activeIndex === index
                ? `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`
                : 'var(--border-color, rgba(0, 0, 0, 0.1))',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            boxShadow:
              activeIndex === index ? `0 2px 8px ${primaryColor}33` : 'none',
          }}
          aria-label={`Go to item ${index + 1}`}
        />
      ))}
    </div>
  );
};

export default NavigationDots;
